import React from 'react';
import AACChromeAPI from '@amzn/aac-chrome-api';
import { AttributesLink } from './Link';
import { AttributesKeyValue } from './KeyValue';
import { AttributesToggle } from './Toggle';
import { AttributesBar } from './Bar';
import {
  Activation,
  ATTRIBUTE_TYPE,
  AttributeTypes,
  Bar,
  KeyValue,
  Link,
  TextLinkPopover,
  TextLinkPopoverRemote,
  Toggle,
} from '../types';
import { AttributesActivation } from './Activation';
import { AttributesTextLinkPopover } from './TextLinkPopover';
import { getClickEventHandler } from 'src/commons/utils';
import { logger } from 'src/commons/utils/logger';
import { AttributionProvider } from './AttributionContext';
import { PageHeaderBundleProvider } from 'src/providers/PantherLocalizationProvider';

export const Attributes: React.VFC<{
  attributes: Array<AttributeTypes>;
}> = ({ attributes }) => {
  let eventHandler;
  const attributesElement = attributes.map(
    (attributeTemplate: AttributeTypes) => {
      let attribute;
      switch (attributeTemplate.type) {
        case ATTRIBUTE_TYPE.TOGGLE:
          attribute = attributeTemplate as Toggle;
          eventHandler = getClickEventHandler(
            attribute,
            AACChromeAPI.getAttributeEventTarget(),
          );
          return (
            <AttributesToggle
              {...attribute}
              eventHandler={eventHandler}
              key={attribute.id}
            />
          );
        case ATTRIBUTE_TYPE.KEY_VALUE:
          attribute = attributeTemplate as KeyValue;
          return (
            <AttributesKeyValue
              {...attribute}
              valueKey={attribute.key}
              key={attribute.id}
            />
          );
        case ATTRIBUTE_TYPE.LINK:
          attribute = attributeTemplate as Link;
          return <AttributesLink {...attribute} key={attribute.id} />;
        case ATTRIBUTE_TYPE.BAR:
          attribute = attributeTemplate as Bar;
          return (
            <AttributesBar
              {...attribute}
              key={attribute.id}
              type={ATTRIBUTE_TYPE.BAR}
            />
          );
        case ATTRIBUTE_TYPE.ACTIVATION:
          attribute = attributeTemplate as Activation;
          return (
            <PageHeaderBundleProvider key={attribute.id}>
              <AttributesActivation {...attribute} />
            </PageHeaderBundleProvider>
          );
        case ATTRIBUTE_TYPE.TEXTLINK_POPOVER:
          attribute = attributeTemplate as TextLinkPopover;
          return (
            <AttributesTextLinkPopover {...attribute} key={attribute.id} />
          );
        case ATTRIBUTE_TYPE.TEXTLINK_POPOVER_REMOTE:
          attribute = attributeTemplate as TextLinkPopoverRemote;
          return (
            <AttributesTextLinkPopover {...attribute} key={attribute.id} />
          );
        default:
          logger.error(
            `Unsupported Attribute type, returning empty item. type: ${attributeTemplate.type}`,
          );
          return '';
      }
    },
  );

  return <AttributionProvider>{attributesElement}</AttributionProvider>;
};
